export default "__VITE_ASSET__DICzKczq__"